import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const configured = Boolean(url && key && !url.includes('YOUR-PROJECT'));

// Лише публічний anon key. Усі права — через RLS і серверні функції.
export const supabase = createClient(configured ? url : 'http://localhost:54321', configured ? key : 'missing', {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: 'pkce' },
});

export const siteUrl = () => import.meta.env.VITE_SITE_URL || window.location.origin;
